import { useState, useEffect } from "react";
import { useYQMCalendar, TimelineData } from "./useYQMCalendar";

export const useQuarterState = () => {
  const { calendarData, years, loading: calLoading } = useYQMCalendar();

  const [year, setYear] = useState<string>("");
  const [quarter, setQuarter] = useState<number>(1);
  const [timeline, setTimeline] = useState<TimelineData | null>(null);

  useEffect(() => {
    if (!calLoading && years.length > 0) {
      const defaultYear = years[0];
      setYear(defaultYear);

      const yearData = calendarData.find((y) => y.year === defaultYear);
      if (!yearData) return;

      const today = new Date();
      const todayUTC = new Date(
        Date.UTC(
          today.getUTCFullYear(),
          today.getUTCMonth(),
          today.getUTCDate()
        )
      );

      const quarters = [
        { q: 1, start: yearData.q1Begin, end: yearData.q1End, cp1: yearData.q1CP1, cp2: yearData.q1CP2, cp3: yearData.q1CP3 },
        { q: 2, start: yearData.q2Begin, end: yearData.q2End, cp1: yearData.q2CP1, cp2: yearData.q2CP2, cp3: yearData.q2CP3 },
        { q: 3, start: yearData.q3Begin, end: yearData.q3End, cp1: yearData.q3CP1, cp2: yearData.q3CP2, cp3: yearData.q3CP3 },
        { q: 4, start: yearData.q4Begin, end: yearData.q4End, cp1: yearData.q4CP1, cp2: yearData.q4CP2, cp3: yearData.q4CP3 },
      ];

      let currentQuarterObj =
        quarters.find(
          (q) =>
            todayUTC >= new Date(q.start) &&
            todayUTC <= new Date(q.end)
        ) ?? quarters[3];

      setQuarter(currentQuarterObj.q);
      setTimeline({
        quarterStart: currentQuarterObj.start,
        quarterEnd: currentQuarterObj.end,
        cp1: currentQuarterObj.cp1,
        cp2: currentQuarterObj.cp2,
        cp3: currentQuarterObj.cp3,
      });
    }
  }, [calLoading, years, calendarData]);

  const handleQuarterYearChange = (
    newYear: string,
    newQuarter: number
  ) => {
    setYear(newYear);
    setQuarter(newQuarter);

    const yearData = calendarData.find((y) => y.year === newYear);
    if (!yearData) return;

    const map: Record<number, any> = {
      1: { start: yearData.q1Begin, end: yearData.q1End, cp1: yearData.q1CP1, cp2: yearData.q1CP2, cp3: yearData.q1CP3 },
      2: { start: yearData.q2Begin, end: yearData.q2End, cp1: yearData.q2CP1, cp2: yearData.q2CP2, cp3: yearData.q2CP3 },
      3: { start: yearData.q3Begin, end: yearData.q3End, cp1: yearData.q3CP1, cp2: yearData.q3CP2, cp3: yearData.q3CP3 },
      4: { start: yearData.q4Begin, end: yearData.q4End, cp1: yearData.q4CP1, cp2: yearData.q4CP2, cp3: yearData.q4CP3 },
    };

    const qData = map[newQuarter] ?? map[1];

    setTimeline({
      quarterStart: qData.start,
      quarterEnd: qData.end,
      cp1: qData.cp1,
      cp2: qData.cp2,
      cp3: qData.cp3,
    });
  };

  return { year, quarter, timeline, years, calLoading, handleQuarterYearChange };
};
